import { Pipe, PipeTransform } from '@angular/core';
import { TIME_SHORT_FORMAT, EMPTY_TIME_PLACEHOLDER } from '../constants/date-config';
import { format } from 'date-fns';

@Pipe({
  name: 'timestampToHours',
})
export class TimestampToHoursPipe implements PipeTransform {
  transform(value: Date | string | number | null | undefined): string {
    return value ? format(new Date(value), TIME_SHORT_FORMAT) : EMPTY_TIME_PLACEHOLDER;
  }
}
